import React from 'react';

interface LDGrowthIconProps {
  className?: string;
  size?: number;
}

export const LDGrowthIcon: React.FC<LDGrowthIconProps> = ({ 
  className = "", 
  size = 32 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background Circle */}
      <circle
        cx="24"
        cy="24"
        r="22"
        fill="url(#ldGradient)"
        stroke="rgba(255, 255, 255, 0.2)"
        strokeWidth="2"
      />
      
      {/* Growth Arrow */}
      <path
        d="M14 30L20 24L26 28L34 18"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Arrow Head */}
      <path
        d="M30 18L34 18L34 22"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Data Points */}
      <circle cx="14" cy="30" r="2" fill="white" />
      <circle cx="20" cy="24" r="2" fill="white" />
      <circle cx="26" cy="28" r="2" fill="white" />
      <circle cx="34" cy="18" r="2" fill="white" />
      
      {/* Leadership Symbol (L) */}
      <path
        d="M16 12L16 20L22 20"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Development Symbol (D) */}
      <path
        d="M26 12L26 20L30 20C31.1046 20 32 19.1046 32 18V14C32 12.8954 31.1046 12 30 12L26 12Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Gradient Definition */}
      <defs>
        <linearGradient
          id="ldGradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0%" stopColor="#E51636" />
          <stop offset="100%" stopColor="#C41230" />
        </linearGradient>
        
        {/* Glow Effect */}
        <filter id="glow">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
};

export default LDGrowthIcon;
